import api from "./api-service";

class DivisionService {
   async getDivisions(filter) {
    return await api.get("/Division/GetDivisions", {
      params: filter,
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
        if (response.data) {
          return response.data;
        }
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  }
}
export default new DivisionService();